import './autocomplete.js';
import './jquery.numeric.js';



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/vendors.js